import { API_BASE } from './api-base';
import { FULLSTORY_RECORDING_SPEC, toggleOverride } from './dev-feature-toggles';

/**
 * Client read of the FullStory recording gate (`/api/flags/fullstory-recording`, Conductor feature toggle
 * `symphonyFullStoryRecording`). Fails CLOSED: no answer means no recording. A dev-tools Feature toggles
 * override wins over the server. Memoized per page load; only a real answer is remembered.
 */
const GATE_TIMEOUT_MS = 2500;

let cached: Promise<boolean> | null = null;

export function fullStoryRecordingEnabled(): Promise<boolean> {
  const forced = toggleOverride(FULLSTORY_RECORDING_SPEC);
  if (forced !== undefined) return Promise.resolve(forced === 'true');
  if (cached) return cached;
  cached = (async () => {
    try {
      const res = await fetch(`${API_BASE}/api/flags/fullstory-recording`, { credentials: 'include', signal: AbortSignal.timeout(GATE_TIMEOUT_MS) });
      if (res.ok) return ((await res.json()) as boolean) === true;
    } catch {
      // closed for now; asked again by the next reader
    }
    cached = null;
    return false;
  })();
  return cached;
}
